import {ImportModel} from "../../models/import/ImportModel";
import {NotificationService} from "../../services/NotificationService";
import {BaseEntity} from "../../entities/BaseEntity";
import { StateService } from "@uirouter/angularjs";

export class ImportFixErrorsCtrl<T extends BaseEntity>{
    public static $inject = ['$scope','$state','ImportModel','NotificationService'];
    currentPage:number = 1;
    working:boolean = false;
    constructor(public $scope:any, public stateService:StateService, public model:ImportModel<T>, public notifyService:NotificationService) {
        this.$scope.vm = this;
        this.$scope.$watch(() => this.currentPage,(newValue: string, oldValue: string) => {
            if(newValue != oldValue) {

            }
        });
    }
    previous():void{
        this.stateService.go(this.model.getRoute("mapfields"));
    }
    skip():void{
        var errorEntity = this.model.errorEntities[this.currentPage-1];
        this.model.errorEntities.splice(this.currentPage-1,1);
        var index = this.model.entities.indexOf(errorEntity);
        this.model.errors.splice(index,1);
        this.model.errorsCount--;
        this.model.entities.splice(index,1);
        this.model.skipped.push(this.model.csvData[index]);
        if(this.model.errorEntities.length == 0)
            this.next();
    }
    skipAll():void{
        for (var i = this.model.errorEntities.length - 1; i >= 0; i--) {
            var entity = this.model.errorEntities[i];

            this.model.errorEntities.splice(i,1);
            var index = this.model.entities.indexOf(entity);
            this.model.errors.splice(index,1);
            this.model.errorsCount--;
            this.model.entities.splice(index,1);
            this.model.skipped.push(this.model.csvData[index]);
            //this.model.skipped.push(entity);
            //this.model.entities.splice(i, 1);
        }
        this.next();
    }
    next():void{
      this.working = true;
      this.model.doImport(true).then((ok)=>{
            if(ok){
                if(this.model.entities.length == 0)
                    this.stateService.go(this.model.getRoute("summary"));
                else
                    this.stateService.go(this.model.getRoute("confirm"));
            }
            else
            {
                this.currentPage = 1;
                this.stateService.go(this.model.getRoute("fixerrors"));
            }
      }).catch((exc)=>{
        this.notifyService.notifyError("Got error in testing import:"+exc);
      }).finally(()=>{
        this.working = false;
      });
    }
}
